import { OrderItem } from 'gql/graphql';
import React from 'react';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import { BasketDelivery, BasketItem, BasketItemAttr, BasketVoucher, BasketTotal } from './types';
import useBasketData from './useBasketData';

export interface BasketRenderComponentProps {
  onRemoveItem: (orderItemId: number) => void;
  onEditItem: (orderItemId: number) => void;
  onApplyVoucher: (voucherCode: string) => void;
  onRemoveVoucher: (voucherId: string) => void;
  onChangeSelector: (orderItemId: number, attr: BasketItemAttr) => void;
  onCheckout: () => void;
}

interface BasketMainProps {
  desktopRender: React.FC<BasketRenderComponentProps>;
  mobileRender: React.FC<BasketRenderComponentProps>;
}

const BasketMain: React.FC<BasketMainProps> = ({ desktopRender, mobileRender }) => {
  const isDesktopDevice = useSelector(isDesktop);
  const BasketRenderer = isDesktopDevice ? desktopRender : mobileRender;

  const { onRemoveItem, onEditItem, onApplyVoucher, onRemoveVoucher, onChangeSelector } = useBasketData();

  const onCheckout = () => {};

  return (
    <BasketRenderer
      onRemoveItem={onRemoveItem}
      onEditItem={onEditItem}
      onApplyVoucher={onApplyVoucher}
      onRemoveVoucher={onRemoveVoucher}
      onChangeSelector={onChangeSelector}
      onCheckout={onCheckout}
    />
  );
};

export default BasketMain;
